import styled from 'styled-components'
import { isEmpty } from 'ramda'
import { v4 as uuidv4 } from 'uuid'
import { colors, fontWeights, breakpoints } from '@/styles'
import ViewComponent from './view-component'

const Wrapper = styled.div``

const TableTitle = styled.p`
  font-weight: ${fontWeights.medium};
  font-size: 20px;
  line-height: 28px;
  color: ${colors.grey16};
  margin: 0 0 20px 0;
  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 10px;
    padding: 0 12px;
  }
`

const DataContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  > :nth-child(odd) {
    padding-bottom: ${props => (props.renderEmpty ? '10px' : '20px')};
    border-bottom: 1px solid ${colors.grey88};
    margin-bottom: ${props => (props.renderEmpty ? '0' : '20px')};
  }

  > :last-child {
    border-bottom: none;
  }

  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    > :not(:last-child) {
      border-bottom: 1px solid ${colors.grey88};
    }
  }
`

const AvatarTable = ({ title, data, columns = 1, emptyComponent }) => {
  const noData = isEmpty(data)
  const renderEmpty = emptyComponent ? emptyComponent : null
  const renderColumns = noData ? 1 : columns
  return (
    <Wrapper key={uuidv4()}>
      <TableTitle>{title}</TableTitle>
      <DataContainer renderEmpty={renderEmpty} columns={renderColumns}>
        {noData ? renderEmpty : data?.map(item => <ViewComponent key={uuidv4()} data={item} />)}
      </DataContainer>
    </Wrapper>
  )
}

export default AvatarTable
